import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CitiesPage from "./pages/CitiesPage";
import CityPage from "./pages/CityPage";
import ServiceCityPage from "./pages/ServiceCityPage";
import JobsPage from "./pages/JobsPage";
import ForCaregivers from "./pages/ForCaregivers";
import ForFamilies from "./pages/ForFamilies";
import HowItWorks from "./pages/HowItWorks";
import About from "./pages/About";
import Blog from "./pages/Blog";
import FAQPage from "./pages/FAQPage";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AuthPage from "./pages/AuthPage";
import PostJobPage from "./pages/PostJobPage";
import CheckoutPage from "./pages/CheckoutPage";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import FamilyDashboard from "./pages/FamilyDashboard";
import CaregiverDashboard from "./pages/CaregiverDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { JobModalProvider } from "./context/JobModalContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <JobModalProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cities" element={<CitiesPage />} />
              <Route path="/jobs" element={<JobsPage />} />
              <Route path="/for-families" element={<ForFamilies />} />
              <Route path="/for-caregivers" element={<ForCaregivers />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/city/:slug" element={<CityPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/post-job" element={<ProtectedRoute role="family"><PostJobPage /></ProtectedRoute>} />
              <Route path="/checkout/:jobId" element={<ProtectedRoute role="family"><CheckoutPage /></ProtectedRoute>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/dashboard" element={<ProtectedRoute role="family"><FamilyDashboard /></ProtectedRoute>} />
              <Route path="/caregiver" element={<ProtectedRoute role="caregiver"><CaregiverDashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
              <Route path="/:landingSlug" element={<ServiceCityPage />} />
            </Routes>
          </JobModalProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
